export default "__VITE_ASSET__IIYo5xD3__"